/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export * from "./IActionResource";
export * from "./IAssetResource";
export * from "./IDirectoryResource";
export * from "./IEndpointResource";
export * from "./IIntegrationResource";
export * from "./IManifestResource";
export * from "./IReadmeResource";
export * from "./IRoutesResource";
export * from "./IThemeResource";
export * from "./ITranslationResource";
export * from "./IViewResource";

export * from "./ActionResourceV1";
export * from "./DirectoryResourceV1";
export * from "./IntegrationResourceV1";
export * from "./ManifestResourceV1";
export * from "./ReadmeResourceV1";
export * from "./RoutesResourceV1";
export * from "./TranslationResourceV1";
export * from "./ThemeResourceV1";
export * from "./ViewResourceV1";
